import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    root: {
    },
});

const Blank = (props) => {
    const { t, classes } = props;

    useEffect(() => {
        
    }, []);

    return (
        <>
            Blank
        </>
    );    
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({  
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Blank);
